import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { switchMap, tap } from 'rxjs/operators';
import { BehaviorSubject, timer } from 'rxjs';
import { Store } from '@ngxs/store';
import { ToastNewApplicationVersionIsAvailable } from '../../store/notification/notification-toastr/notification-toastr.actions';

@Injectable({
   providedIn: 'root',
})
export class UpdateService {
   public newVersionAvailable$ = new BehaviorSubject(false);

   constructor(private swUpdate: SwUpdate, private store: Store) {}

   public initialize() {
      this.swUpdate.available
         .pipe(
            tap((event) => console.debug(`Current version is ${event.current.hash}. Next available version is ${event.available.hash}`)),
            switchMap(() => this.swUpdate.activateUpdate())
         )
         .subscribe();

      this.swUpdate.activated.subscribe((event) => {
         console.debug(`Updated to version ${event.current.hash}. Previous available version was ${event.previous.hash}`);
         this.newVersionAvailable$.next(true);
         this.store.dispatch(new ToastNewApplicationVersionIsAvailable());
      });

      timer(0, 30000)
         .pipe(
            tap(() => console.debug('Checking for updates')),
            switchMap(() => this.swUpdate.checkForUpdate())
         )
         .subscribe();
   }
}
